export function HighlightedText({ text, highlight, onClick, color }) {
    // Split text into parts around the highlight
    const parts = text.split(new RegExp(`(${highlight})`, "gi"));
  
    return (
      <span onClick = {()=>onClick()}>
        {parts.map((part, index) =>
          part.toLowerCase() === highlight.toLowerCase() ? (
            <span key={index} style={{ color: "white" }}>
              {part}
            </span>
          ) : (
            <span key={index} style={{ color: color }}>
              {part}
            </span>
          )
        )}
      </span>
    );
  }
  